import React from 'react';
import DevenirAdherent from '../components/DevenirAdherent';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <DevenirAdherent />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
